.settings-panel {
	position: relative;
	display: grid;
	place-items: center;
}

.settings-trigger {
	display: grid;
	width: 46px;
	height: 46px;
	padding: 0;
	place-items: center;
	border: 0;
	border-radius: 0;
	color: var(--ink, #252134);
	background: #fff;
	cursor: pointer;
	line-height: 1;
	transition:
		color 0.14s ease,
		background 0.14s ease;
}

.settings-trigger:hover,
.settings-trigger[aria-expanded='true'] {
	color: #fff;
	background: var(--purple, #6558e8);
}
.settings-trigger:disabled,
.settings-trigger:disabled:hover {
	color: #8c8793;
	background: #e7e4ea;
	cursor: not-allowed;
}

.settings-backdrop {
	position: fixed;
	z-index: 2000;
	inset: 0;
	display: grid;
	place-items: center;
	padding: 20px;
	background: rgba(37, 33, 52, 0.58);
	backdrop-filter: blur(8px);
}

.settings-dialog {
	width: min(540px, 100%);
	display: flex;
	flex-direction: column;
	height: min(640px, calc(100dvh - 40px));
	overflow: hidden;
	border: 2px solid var(--ink, #252134);
	border-radius: 0;
	color: var(--ink, #252134);
	background: #f8f7fa;
}

.settings-dialog > header {
	flex-shrink: 0;
	display: flex;
	min-height: 70px;
	align-items: center;
	justify-content: space-between;
	padding: 0 12px 0 20px;
	border-bottom: 2px solid var(--ink, #252134);
	background: #ffd447;
}

.settings-dialog > header > div {
	display: flex;
	align-items: center;
	gap: 11px;
}
.settings-dialog h2 {
	margin: 0;
	font-size: 22px;
	letter-spacing: -0.03em;
}
.settings-dialog header :global(.settings-glyph) {
	width: 34px;
	height: 34px;
	border: 2px solid var(--ink, #252134);
	background: #fff;
}
.settings-close {
	display: grid;
	width: 42px;
	height: 42px;
	padding: 0;
	place-items: center;
	border: 2px solid var(--ink, #252134);
	color: var(--ink, #252134);
	background: #fff;
	cursor: pointer;
	font-size: 24px;
}
.settings-close:hover {
	color: #fff;
	background: #ff637a;
}

.settings-section {
	display: grid;
	grid-template-columns: 150px minmax(0, 1fr);
	gap: 16px;
	padding: 18px;
}
.settings-keybindings-section {
	grid-template-columns: minmax(0, 1fr);
}
.settings-section-copy {
	padding: 9px 3px;
}
.settings-section-copy strong,
.settings-section-copy span {
	display: block;
}
.settings-section-copy strong {
	font-size: 15px;
}
.settings-section-copy span {
	margin-top: 5px;
	color: #77717f;
	font-size: 14px;
	line-height: 1.45;
}

.language-options,
.auto-pause-options {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	border: 2px solid var(--ink, #252134);
}
.language-options button,
.auto-pause-options button {
	display: grid;
	grid-template-columns: 34px minmax(0, 1fr) 18px;
	min-height: 64px;
	align-items: center;
	gap: 8px;
	padding: 7px 9px;
	border: 0;
	border-right: 1px solid var(--ink, #252134);
	color: var(--ink, #252134);
	background: #fff;
	cursor: pointer;
	text-align: left;
}
.language-options button:last-child,
.auto-pause-options button:last-child {
	border-right: 0;
}
.language-options button:hover,
.auto-pause-options button:hover {
	background: #efedf3;
}
.language-options button[aria-pressed='true'],
.auto-pause-options button[aria-pressed='true'] {
	background: color-mix(in srgb, var(--purple, #6558e8) 18%, #fff);
	box-shadow: inset 0 -7px 0 var(--purple, #6558e8);
}
.language-options button > span,
.auto-pause-options button > span {
	display: grid;
	width: 32px;
	height: 32px;
	place-items: center;
	color: #fff;
	background: var(--purple, #6558e8);
	font-size: 14px;
	font-weight: 900;
}
.language-options button:nth-child(2) > span,
.auto-pause-options button:nth-child(2) > span {
	color: var(--ink, #252134);
	background: #ff637a;
}
.language-options button b,
.auto-pause-options button b {
	font-size: 13px;
}
.language-options button i,
.auto-pause-options button i {
	color: var(--purple, #6558e8);
	font-size: 15px;
	font-style: normal;
	font-weight: 900;
	text-align: center;
}

.settings-auto-pause-section {
	align-items: center;
	border-bottom: 2px solid var(--ink, #252134);
	border-top: 2px solid var(--ink, #252134);
	background: #f0edff;
}
.settings-auto-pause-section .settings-section-copy {
	padding-block: 0;
}
.auto-pause-options button > span {
	font-family: var(--font-mono);
	font-size: 13px;
}

.settings-storage-section {
	border-block: 2px solid var(--ink, #252134);
	background: #fff;
}
.settings-storage-action {
	display: flex;
	min-width: 0;
	flex-direction: column;
	justify-content: center;
}
.settings-storage-action button {
	min-height: 48px;
	padding: 8px 12px;
	border: 2px solid var(--ink, #252134);
	color: var(--ink, #252134);
	background: #fff;
	cursor: pointer;
	font-weight: 850;
	text-align: left;
}
.settings-storage-action button:hover {
	background: color-mix(in srgb, #ff637a 18%, #fff);
}
.settings-storage-action button.armed {
	color: #fff;
	background: #d9284e;
}
.settings-storage-action button:disabled {
	cursor: default;
	opacity: 0.72;
}
.settings-storage-action > span {
	min-height: 25px;
	padding-top: 6px;
	color: #a31c3b;
	font-size: 11px;
	line-height: 1.25;
}

:global(.top-actions) > .settings-panel .settings-trigger {
	width: 100%;
	height: 100%;
	border: 0;
	border-radius: 0;
}

@media (max-width: 620px) {
	:global(.top-actions) > .settings-panel .settings-trigger {
		width: 100%;
		height: 100%;
		border-radius: 0;
	}
	.settings-backdrop {
		padding: 10px;
	}
	.settings-dialog > header {
		min-height: 62px;
		padding-left: 15px;
	}
	.settings-dialog h2 {
		font-size: 19px;
	}
	.settings-section {
		grid-template-columns: 1fr;
		gap: 8px;
		padding: 13px;
	}
	.settings-section-copy {
		padding: 3px 1px;
	}
	.language-options button,
	.auto-pause-options button {
		min-height: 60px;
	}
	.settings-storage-action > span {
		min-height: 20px;
	}
}

.settings-categories {
	display: grid;
	grid-template-columns: repeat(4, minmax(0, 1fr));
	flex-shrink: 0;
	border-bottom: 2px solid var(--ink, #252134);
	background: #efedf3;
}
.settings-categories button {
	display: grid;
	place-items: center;
	width: 100%;
	height: 58px;
	padding: 12px;
	border: 0;
	border-right: 1px solid var(--ink, #252134);
	border-radius: 0;
	color: var(--ink, #252134);
	background: #fff;
	cursor: pointer;
}
.settings-categories button svg {
	width: 24px;
	height: 24px;
}
.settings-categories button:hover {
	background: #e2ddff;
}
.settings-categories button[aria-selected='true'] {
	color: var(--purple, #6558e8);
	background: #e2ddff;
	box-shadow: inset 0 -5px 0 var(--purple, #6558e8);
}
.settings-categories button:last-child {
	border-right: 0;
}
.settings-categories button:focus-visible {
	outline: none;
}
.settings-content {
	flex: 1;
	min-height: 0;
	overflow-y: auto;
	overscroll-behavior: contain;
	scrollbar-gutter: stable;
}
.settings-content:focus-visible {
	outline: 2px solid var(--purple, #6558e8);
	outline-offset: -4px;
}
.settings-content > .settings-section:first-child {
	border-top: 0;
}
@media (max-width: 620px) {
	.settings-dialog {
		height: min(640px, calc(100dvh - 20px));
	}
	.settings-categories button {
		height: 52px;
	}
}

.settings-info {
	padding: 20px;
}
.settings-info header {
	display: grid;
	gap: 10px;
	padding: 16px;
	border: 2px solid var(--ink);
	background: var(--yellow);
}
.settings-info header strong {
	font-size: 24px;
}
.settings-info header span {
	font-family: var(--font-mono);
	font-size: 12px;
}
.settings-info a {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	min-height: 58px;
	padding: 14px 16px;
	border: 2px solid var(--ink);
	border-top: 0;
	color: var(--ink);
	background: #fff;
	text-decoration: none;
	font-size: 14px;
	font-weight: 750;
}
.settings-info a:hover {
	background: #e2ddff;
}
.settings-info a:focus-visible {
	outline: 2px solid var(--purple);
	outline-offset: -5px;
}
